/**
 * @description 保單寄送方式 Value (enum)
 */
export enum PolicyDeliveryTypeValuesEnum {
  /** 不寄送 */
  None = '0',
  /** 電子保單 */
  Electronic = '1',
  /** 紙本保單 */
  Paper = '2'
}
